import logo from './logo.svg';
import './App.css';
import React from 'react';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

class Header extends React.Component {
  constructor(props) {
    super(props);
  }
    render() {
      return ( 
        <h1 className='header-text'>SPLI<br />TTER</h1>
      )
    }
  }

  class Calculator extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        billTotal: '',
        tipPercent: 0,
        numPeople: '',
      }
      this.changeBillTotal = this.changeBillTotal.bind(this)
      this.changeNumPeople = this.changeNumPeople.bind(this)
      this.changeTipValueFive = this.changeTipValueFive.bind(this)
      this.changeTipValueTen = this.changeTipValueTen.bind(this)
      this.changeTipValue15 = this.changeTipValue15.bind(this)
      this.changeTipValue20 = this.changeTipValue20.bind(this)
      this.changeTipValue25 = this.changeTipValue25.bind(this)
      this.reset = this.reset.bind(this)
      this.changeTipValueCustom = this.changeTipValueCustom.bind(this)
    }
      changeBillTotal(event) {
        this.setState(state => ({
          billTotal: (event.target.value)
        }));
      }
      changeNumPeople(event) {
        this.setState(state => ({
          numPeople: (event.target.value)
        }));
      }
      changeTipValueFive() {
        this.setState(state => ({
          tipPercent: 0.05,
        }));
      }
      changeTipValueTen() {
        this.setState(state => ({
          tipPercent: 0.10,
        }));
      }
      changeTipValue15() {
        this.setState(state => ({
          tipPercent: 0.15,
        }));
      }
      changeTipValue20() {
        this.setState(state => ({
          tipPercent: 0.20,
        }));
      }
      changeTipValue25() {
        this.setState(state => ({
          tipPercent: 0.25,
        }));
      }
      reset() {
        this.setState(state => ({
          tipPercent: 0,
          billTotal: '',
          numPeople: '',
        }));
      }
      changeTipValueCustom(event) {
        this.setState(state => ({
          tipPercent: (event.target.value / 100),
        }));
      }
      

      render() {

        const buttonVals = [
          0.05,
          0.10,
        ]

        if (this.state.numPeople > 0 || this.state.numPeople === '') {
          return ( 
            <div  className='calc-boxes'> 
              <div>
                <p>Bill</p>
                <input onChange={this.changeBillTotal} value={this.state.billTotal}></input>
                {/* <p>{this.state.billTotal}</p> */}
  
                <p>Select Tip %</p>
                <div className='tip-buttons'>
                  <button onClick={this.changeTipValueFive}>5%</button>
                  <button onClick={this.changeTipValueTen}>10%</button>
                  <button onClick={this.changeTipValue15}>15%</button>
                  <button onClick={this.changeTipValue20}>20%</button>
                  <button onClick={this.changeTipValue25}>25%</button>
                  <input onChange={this.changeTipValueCustom} type="text" placeholder="Custom"></input>
                </div>
                
                
                  <p>Number of people</p>
                  <input onChange={this.changeNumPeople} value={this.state.numPeople}>
                  </input>

                </div>
  
              <div className='totals-box'>
                <Totals billTotal = {this.state.billTotal} numPeople = {this.state.numPeople} tipPercent = {this.state.tipPercent}/>
                <button onClick={this.reset}>Reset</button>
              </div>
              
            </div>
          )
        } else  {
          return ( 
            <div  className='calc-boxes'> 
              <div>
                <p>Bill</p>
                <input onChange={this.changeBillTotal} value={this.state.billTotal}></input>
                {/* <p>{this.state.billTotal}</p> */}
  
                <p>Select Tip %</p>
                <div className='tip-buttons'>
                  <button onClick={this.changeTipValueFive}>5%</button>
                  <button onClick={this.changeTipValueTen}>10%</button>
                  <button onClick={this.changeTipValue15}>15%</button>
                  <button onClick={this.changeTipValue20}>20%</button>
                  <button onClick={this.changeTipValue25}>25%</button>
                  <input onChange={this.changeTipValueCustom} type="text" placeholder="Custom"></input>
                </div>
                
                
                  <p>Number of people <span style={{'color':'red', 'margin-left':'1em'}}>Can't Be Zero</span></p>
                  <input style={{border: '2px solid red'}} onChange={this.changeNumPeople} value={this.state.numPeople}></input>
  
                </div>
  
              <div className='totals-box'>
                <Totals billTotal = {this.state.billTotal} numPeople = {this.state.numPeople} tipPercent = {this.state.tipPercent}/>
                <button onClick={this.reset}>Reset</button>
                
              </div>
              
            </div>
          )
        }

        
      }
    }  

    class Totals extends React.Component {
      constructor(props) {
        super(props);
      }
        render() {

          const totalPerPerson = (parseFloat(this.props.billTotal) + parseFloat((parseFloat(this.props.billTotal) * parseFloat(this.props.tipPercent)))) 
          / parseFloat(this.props.numPeople)

          const tipPerPerson = (
            (parseFloat(this.props.billTotal) * parseFloat(this.props.tipPercent))
            / parseFloat(this.props.numPeople) 
          )

          if (this.props.numPeople > 0 && this.props.billTotal > 0) {
            return ( 
              <div  className='totals'>
                <div><span>Tip Amount <span className='perPerson'><br/>/ person</span></span>  <span className='total-amounts'>{'$' + tipPerPerson.toFixed(2)}</span></div>
                <div><span>Total Amount <span className='perPerson'><br/>/ person</span></span>  <span className='total-amounts'>{'$' + totalPerPerson.toFixed(2)}</span></div>
              </div>
            )
          } else {
            return ( 
              <div  className='totals'>
                <div><span>Tip Amount <span className='perPerson'><br/>/ person</span></span>  <span className='total-amounts'>$0.00</span></div>
                <div><span>Total Amount <span className='perPerson'><br/>/ person</span></span>  <span className='total-amounts'>$0.00</span></div>
              </div>
            )
          }
        }
      }
      

function App() {
  return (
    <div>
      <Header />
      <div className='container'>
        <Calculator />
      </div>
    </div>
  );
}

//TO-DO: List
/*
CHECK** Add input validation and styling for zero people 
CHECK** Add reset placeholder values for inputs in reset func
NIXED** Add default focus button?
Style according to guidelines
adjust styles for various screens and queiries
organize code and components
First react project fully done. 
*/

export default App;
